import { BoxProps, Divider } from '@mui/material';

import { ReactNodeProps, useScreenSize } from 'common';

import { Box, Title } from '..';

interface CustomBoxProps extends BoxProps {
    title: string;
    button?: string | JSX.Element;
    children: ReactNodeProps['children'];
}

export const CustomBox = ({ title, button, children, ...props }: CustomBoxProps) => {
    const { isDesktopSize } = useScreenSize();

    return (
        <Box sx={{ paddingY: 4 }} {...props}>
            <Box
                sx={{
                    paddingBottom: 4,

                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Title
                        variant={isDesktopSize ? 'h5' : 'h6'}
                        fontWeight={700}
                        sx={{ color: '#af0000' }}
                    >
                        {title}
                    </Title>

                    <Divider
                        sx={{
                            marginTop: 1,

                            height: 2,
                            width: '100%',

                            borderRadius: 8,
                            background: '#af0000'
                        }}
                    />
                </Box>

                <Box>{button}</Box>
            </Box>

            {children}
        </Box>
    );
};
